import React from 'react';
import PropTypes from 'prop-types';
import BasketGroups from './basket-groups';
import BasketTotal from './basket-total';
import BasketPayButtons from './basket-pay-buttons';
import BasketErrors from './basket-errors';
import gtm, { ecommerceEventTypes } from '../../../general/js/gtm';
import TrackingHelper from '../../../general/js/basket/tracking-helper';
import { CURRENCY_RATIO, currencyIsoCodes } from '../../../general/js/basket/currency-helper';

export default class Basket extends React.Component {
    constructor(props) {
        super(props);

        this.onCheckout = this.onCheckout.bind(this);
    }

    renderEmpty() {
        return (
            <div className="basket__empty">Your basket is empty</div>
        );
    }

    onCheckout() {
        const productGroupList = this.getProductGroupList(this.props.basket.productGroups);
        const basketItems = TrackingHelper.getBasketProducts(productGroupList);

        gtm.pushEcommerceEvent(ecommerceEventTypes.BEGIN_CHECKOUT, {
            currency: currencyIsoCodes.GBP,
            value: this.props.basket.total / CURRENCY_RATIO,
            items: basketItems
        });

        this.props.onCheckout();
    }

    getProductGroupList(productGroups) {
        return Object.keys(productGroups).map((id) => productGroups[id]);
    }

    render() {
        const productsGroupList = this.getProductGroupList(this.props.basket.productGroups);

        return (
            <div className="basket">
                {productsGroupList.length > 0 ?
                    <React.Fragment>
                        <BasketErrors errors={this.props.errors} />
                        <BasketGroups
                            productGroups={productsGroupList}
                            onUpdateProductQuantity={this.props.onUpdateProductQuantity}
                            hasBallotConfiguration={this.props.hasBallotConfiguration}
                        />
                        <BasketTotal basket={this.props.basket} />
                        <BasketPayButtons
                            basket={this.props.basket}
                            onCheckout={this.onCheckout}
                            tBoxBeforePayment={this.props.showAlertBoxBeforePayment}
                            showAlertBoxBeforePayment={this.props.showAlertBoxBeforePayment}
                            dialogBoxTitle={this.props.dialogBoxTitle}
                            dialogBoxMessage={this.props.dialogBoxMessage}
                            dialogBoxLogo={this.props.dialogBoxLogo}
                            dialogBoxBanner={this.props.dialogBoxBanner}
                        />
                    </React.Fragment> : this.renderEmpty()
                }
            </div>
        );
    }
}

Basket.propTypes = {
    basket: PropTypes.object.isRequired,
    onUpdateProductQuantity: PropTypes.func.isRequired,
    onCheckout: PropTypes.func.isRequired,
    errors: PropTypes.array,
    hasBallotConfiguration: PropTypes.bool,
    showAlertBoxBeforePayment: PropTypes.bool,
    dialogBoxTitle: PropTypes.string,
    dialogBoxMessage: PropTypes.string,
    dialogBoxLogo: PropTypes.string
};
